import type React from "react";

import { BalanceStoreLoader } from "@components/BalanceStoreLoader";
import { LeverageStoreLoader } from "@components/LeverageStoreLoader";
import { MarketStoreLoader } from "@components/MarketStoreLoader";
import { OrderbookAndTradesStoreLoader } from "@components/OrderbookAndTradesStoreLoader";

import { useExternalWallet } from "@hooks/useExternalWallet";

import { useAllTickersSubscription } from "@src/api/ws/all-tickers-subscription";

export const DataLoaderProvider: React.FC = () => {
  // eslint-disable-next-line no-restricted-syntax
  useExternalWallet();
  useAllTickersSubscription();

  return (
    <>
      {/* Loaders for stores */}
      {/* These components will subscribe to the necessary data and update the stores accordingly */}
      <BalanceStoreLoader />
      <MarketStoreLoader />
      <LeverageStoreLoader />
      <OrderbookAndTradesStoreLoader />
    </>
  );
};
